module.exports = __webpack_public_path__ + "static/media/image.fddbab2e.svg";